import React, { useState } from 'react';
import MultipleSelect from '../../../../component/MultipleSelect';
import LoaderButton from '../../../../component/LoaderButton';
import { useDirectSale } from '../../../../hooks/directSale';
import { useInDirectSale } from '../../../../hooks/inDirectSale';
import { useSnackbar } from '../../../../context/SnackBarContext';

export const ManageStocks = ({ data, onClose, setRefetch }) => {
  const { directSale, isLoading } = useDirectSale(onClose, setRefetch)
  const { inDirectSale, isLoading: inDirectSaleLoader } = useInDirectSale(onClose, setRefetch)
const { showSuccess, showError } = useSnackbar();

  const [formData, setFormData] = useState({
    stocks: '',
    salesType: [],
    totalAmount: ''
  });
  const salesTypeOptions = [
    { name: 'Direct Sales', value: 'direct' },
    { name: 'Indirect Sales', value: 'indirect' }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSalesTypeChange = (e) => {
    const selected = Array.isArray(e.target.value) ? e.target.value : [e.target.value];
    const selectedObjects = selected
      .map((val) => salesTypeOptions.find((opt) => opt.name === val))
      .filter(Boolean);
    setFormData((prev) => ({
      ...prev,
      salesType: selectedObjects
    }));
  };


  const validateForm = () => {
  const stocksLeft = parseInt(data?.issue_quantity) - parseInt(data?.quantity);

  if (formData.stocks === '' || formData.stocks === null) {
    showError('Stocks is required');
    return false;
  }

  if (parseInt(formData.stocks) <= 0) {
    showError('Stocks must be greater than 0');
    return false;
  } 
  
  if (parseInt(formData.stocks) > stocksLeft) {
    showError(`Stocks cannot exceed ${stocksLeft}`);
    return false;
  }

  if (!formData.salesType.length) {
    showError('Please select at least one Sales Type');
    return false;
  }

  if (formData.salesType.some(opt => opt.value === 'direct') && !formData.totalAmount) {
    showError('Total Amount is required for Direct Sales');
    return false;
  }

  return true;
};


  const handleSave = () => {
    if (!validateForm()) return;

    if (formData.salesType[0].value == "direct") {
      directSale({ ...formData, quantity: formData.stocks }, data._id)
    } else {
      inDirectSale({ ...formData, quantity: formData.stocks, totalAmount: 0 }, data._id)
    }
  };

  const isDirectSalesSelected = formData.salesType.some(opt => opt.value === 'direct');
  const stocksLeft = parseInt(data?.issue_quantity) - parseInt(data?.quantity);

  return (
    <div className="space-y-4">
      {/* Issue Quantity Display */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1">
          Total Stocks:
        </label>
        <p className="border p-2 rounded bg-gray-100">
          {data?.issue_quantity ?? 'N/A'}
        </p>
      </div>


      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-1">
          Stocks Left:
        </label>
        <p className="border p-2 rounded bg-gray-100">
          {stocksLeft ?? 'N/A'}
        </p>
      </div>

      {/* Stocks Input */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2">Stocks</label>
        <input
          type="number"
          name="stocks"
          value={formData.stocks}
          onChange={handleChange}
          className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
          placeholder="Enter stock quantity"
        />
      </div>

      {/* Sales Type Multi-Select */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2">Sales Type</label>
        <MultipleSelect
          label="Sales Type"
          options={salesTypeOptions}
          value={formData.salesType.map((opt) => opt.name)}
          onChange={handleSalesTypeChange}
          name="salesType"
          placeholder="Select Sales Type"
        />
      </div>

      {/* Total Amount (only for Direct Sales) */}
      {isDirectSalesSelected && (
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Total Amount</label>
          <input
            type="number"
            name="totalAmount"
            value={formData.totalAmount}
            onChange={handleChange}
            className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter total amount"
          />
        </div>
      )}

      {/* Save Button */}
      <div>
        <LoaderButton
          label="Save"
          isLoading={formData.salesType == "indirect" ? isLoading : inDirectSaleLoader}
          handleClick={handleSave}
        />
      </div>
    </div>
  );
};
